import { render, staticRenderFns } from "./RamoVidaComponent.vue?vue&type=template&id=2e0b3a30"
import script from "./RamoVidaComponent.vue?vue&type=script&lang=js"
export * from "./RamoVidaComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports